import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AccountType } from '@iw/core/entities';

@Component({
  selector: 'iw-account-bg',
  template: ``,
  styleUrl: './account-bg.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.card]': 'accountType() === AccountType.BankCard',
    '[class.fiat]': 'accountType() === AccountType.FiatWallet',
    '[class.crypto]': 'accountType() === AccountType.CryptoWallet',
  },
})
export class AccountBgComponent {
  readonly AccountType = AccountType;
  readonly accountType = input.required<AccountType>();
}
